webpackJsonp([115770076398321],{

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HookTutorial = __webpack_require__(50);
	
	var _HookTutorial2 = _interopRequireDefault(_HookTutorial);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _HookTutorial2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 7: Publishing the Hook'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you plan on ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://docs.npmjs.com/audience/publishing-npm-packages' },
	        'publishing your hook to npm'
	      ),
	      ', then you\'ll need to build it before doing so.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can view the finished code for this step by checking out the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'step-7'
	        ),
	        ' branch.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Build the Hook'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Before you publish, you need to run ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'npm install'
	      ),
	      ' inside the hook to build it. Doing this will cause the code will be transpiled and placed into two directories; raw ES5 code will be placed in a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lib/'
	      ),
	      ' directory, and ES5 code that leaves the import/export statements intact (a requirement for tree-shaking) will be placed in an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'es/'
	      ),
	      ' directory.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The final folder structure (after build) will look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      polling-hook\n      |-- es\n      |   |--index.js\n      |-- lib\n      |   |--index.js\n      |-- src\n      |   |--index.js\n      |-- test\n      |   |-- test.spec.js\n      |-- .babelrc\n      |-- package.json\n      |-- README.md\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'That\'s all for this tutorial.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you want to see a more full-featured version of this hook, check out the official ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-hook-polling' },
	        'lore-hook-polling'
	      ),
	      ' hook.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-tutorial-step-7-js-ffa14083603acb924019.js